import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom';
import { get } from '../../helper/helper_api';
import Loader from '../../Loader';

export default function ArtistDetails() {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const [proID, setProID] = useState(null);
    const [artistDetails, setArtistDetails] = useState(null);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        let path = location.pathname.split("/");
        if (path.length > 2) {
            setProID(path[2]);
        }
    }, [location?.pathname]);

    useEffect(() => {
        if (proID) {
            getData();
        }
    }, [proID]);

    const getData = () => {
        setLoader(true);
        window.scroll(0, 0);
        get('/artist/detail?artistId=' + proID).then((json) => {
            setLoader(false);
            if (json?.statusCode == 200) {
                setArtistDetails(json?.data);
            }
        }).catch((err) => {
            console.log(err);
            setLoader(false);
        });
    }

    const openDetail = (item) => {
        const tempId = item?._id.slice(item?._id.length - 4, item?._id.length);
        navigate('/tour/' + tempId + "/" + (item?.name).split(" ").join("-").toLowerCase());
    }

    return (
        <>
            {
                loader && <Loader />
            }
            <div id="tg-wrapper" className="tg-wrapper tg-haslayout">

                {/* <div className="tg-bannerholder tg_innerbanner">
                    <section className="tg-parallax tg-innerbanner">
                        <div className="tg-sectionspace inner_banner tg-haslayout" style={{ backgroundImage: `url(${require('../../assets2/images/about-us-banner_3.jpg')})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }} >
                            <div className="container">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <h1>{artistDetails?.name}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div> */}

                <main id="tg-main" className="tg-main tg-haslayout">

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/artist">Artists</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">{artistDetails?.name}</li>
                        </ol>
                    </nav>

                    {artistDetails && (
                        <>
                            {/* <section className='tg-innerbanner heading_section' id="AtAGlance">
                                <h1>{artistDetails?.name}</h1>
                            </section> */}
                            <section className="glance_sec bg-gray section_box" id="About_The_Artist" style={{ marginTop: 45, padding: '60px 0' }}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="p_sec artist_section">
                                                <div className="sec_title">
                                                    <h2>About the Artist</h2>
                                                </div>
                                                <div dangerouslySetInnerHTML={{ __html: artistDetails?.about }}></div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="id_map mt-0" style={{ marginTop: 0 }}>
                                                <img src={artistDetails?.image} alt={artistDetails?.name} style={{ width: '100%', borderRadius: '10px' }} />
                                                <div className="artist_name_box" style={{ textAlign: 'center', padding: '15px' }}>
                                                    <h5 style={{ margin: '0 0 5px', fontWeight: 'bold', color: '#ffffff' }}>{artistDetails?.name}</h5>
                                                    <span style={{ display: 'block', color: '#ffffff', fontSize: '13px', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '5px', opacity: 0.9 }}>
                                                        {artistDetails?.occupation}
                                                    </span>
                                                    <span style={{ display: 'block', color: '#ffffff', fontSize: '13px' }}>
                                                        <span className="fa fa-map-marker" style={{ marginRight: '5px', color: '#ffffff' }}></span>
                                                        {artistDetails?.countryName || artistDetails?.country || "India"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}

                    <section className="clothe_section pb-100 pt-30px">
                        <div className="container">
                            <div className="sec_title">
                                <h2>Discover Tours with {artistDetails?.name}:</h2>
                            </div>
                            {
                                artistDetails?.tours?.length > 0 ? (
                                    artistDetails?.tours?.map((item, index) => (
                                        <div className="row pt-50" key={index} style={{ marginBottom: '50px' }}>
                                            {index % 2 ?
                                                <>
                                                    <div className="col-md-8">
                                                        <div className="bg-txt">
                                                            <h2 className="et_main" onClick={() => openDetail(item)} style={{ cursor: 'pointer' }}>{item?.name}</h2>
                                                            <p>{item?.overview}</p>
                                                            <div className="known_more_box">
                                                                <button className="learn-more">
                                                                    <span className="circle" aria-hidden="true">
                                                                        <span className="icon arrow"></span>
                                                                    </span>
                                                                    <a onClick={() => openDetail(item)} className="button-text">Know More</a>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="bg-one bg_one_exp">
                                                            <img src={item?.banner} onClick={() => openDetail(item)} style={{ cursor: 'pointer' }} alt={item?.name} />
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className="col-md-4">
                                                        <div className="bg-one bg_one_exp">
                                                            <img src={item?.banner} onClick={() => openDetail(item)} style={{ cursor: 'pointer' }} alt={item?.name} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="bg-txt">
                                                            <h2 className="et_main" onClick={() => openDetail(item)} style={{ cursor: 'pointer' }}>{item?.name}</h2>
                                                            <p>{item?.overview}</p>
                                                            <div className="known_more_box">
                                                                <button className="learn-more">
                                                                    <span className="circle" aria-hidden="true">
                                                                        <span className="icon arrow"></span>
                                                                    </span>
                                                                    <a onClick={() => openDetail(item)} className="button-text">Know More</a>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center" style={{ padding: '60px 0' }}>
                                        <h3>No tours scheduled currently with this artist.</h3>
                                    </div>
                                )
                            }
                        </div>
                    </section>
                </main>
            </div>
        </>
    )
}
